import _extends from "../../../node_modules/@babel/runtime/helpers/esm/extends.es.js";
import { useIsLandscape } from "../useIsLandscape.es.js";
const usePickerLayoutProps = ({
  props,
  propsFromPickerValue,
  propsFromPickerViews,
  wrapperVariant
}) => {
  const {
    orientation
  } = props;
  const isLandscape = useIsLandscape(propsFromPickerViews.views, orientation);
  const layoutProps = _extends({}, propsFromPickerViews, propsFromPickerValue, {
    isLandscape,
    wrapperVariant,
    disabled: props.disabled,
    readOnly: props.readOnly
  });
  return {
    layoutProps
  };
};
export {
  usePickerLayoutProps
};
//# sourceMappingURL=usePickerLayoutProps.es.js.map
